export class DataModel {

    constructor( id = -1, name = '' ){
        this.id = id;
        this.name = name;
    }

    fromJSON( json ){
        if( json ){
            this.id = json.id;
            this.name = json.name;
        }
    }

}